import React from 'react';
import { Link } from 'react-router-dom';

const Messages = () => {
    // Styles
    const mainColor = '#003366';
    const sectionTitleStyle = {
        color: mainColor, 
        borderBottom: `2px solid ${mainColor}`, 
        paddingBottom: '10px', 
        marginBottom: '20px',
        fontSize: '18px', 
        fontFamily: 'serif', 
        textTransform: 'uppercase', 
        fontWeight: 'bold'
    };

    return (
        <div className="container mt-5 mb-5 font-sans">
            
            {/* Header Title (Optional, remove if not needed) */}
            {/* <h2 className="text-center mb-4" style={{color: mainColor, fontFamily: 'serif'}}>CONTACT</h2> */}

            <div className="row">
                
                {/* ================= LEFT SIDEBAR ================= */}
                <div className="col-lg-3 mb-4">
                    <h4 style={sectionTitleStyle}>CONTACTE</h4>
                    <div className="list-group list-group-flush border-bottom">
                         <Link to="#" className="list-group-item list-group-item-action fw-bold border-0 ps-0" style={{fontSize:'14px', color: mainColor}}>
                            <i className="fa fa-chevron-right me-2 text-secondary" style={{fontSize:'10px'}}></i> Programul de audiență la conducerea Guvernului
                        </Link>
                        <Link to="#" className="list-group-item list-group-item-action text-secondary border-0 ps-0" style={{fontSize:'14px'}}>
                            <i className="fa fa-chevron-right me-2" style={{fontSize:'10px'}}></i> Comunicatorii Guvernului
                        </Link>
                    </div>
                </div>

                {/* ================= RIGHT CONTENT ================= */}
                <div className="col-lg-9">
                    <h4 style={sectionTitleStyle}>CONTACT</h4>
                    
                    {/* --- CONTACT INFO & MAP SECTION --- */}
                    <div className="mb-5">
                        <p className="mb-2" style={{fontSize: '14px'}}>
                            <strong>Adresa:</strong> <span className="text-primary fw-bold">Republica Moldova, MD-2012 mun. Chişinău, Piaţa Marii Adunări Naţionale, 1</span>
                        </p>
                        <p className="mb-2" style={{fontSize: '14px'}}>
                            <strong>Telefon:</strong> 022-250-101 <strong>Email:</strong> <a href="mailto:cancelaria@gov.md" className="text-primary fw-bold text-decoration-none">cancelaria@gov.md</a>
                        </p>
                        <p className="mb-2" style={{fontSize: '14px'}}>
                            <strong>Telefon:</strong> 022-250-402, 022-250-383, 022-250-310, 022-250-297 <strong>Email:</strong> <a href="mailto:petitii@gov.md" className="text-primary fw-bold text-decoration-none">petitii@gov.md</a>
                        </p>
                        <p className="mb-4" style={{fontSize: '14px'}}>
                            <strong>Orar de lucru:</strong> Luni - Vineri: 8:00 - 17:00
                        </p>

                        {/* Google Map Image Placeholder (Clickable) */}
                        <div className="border rounded overflow-hidden mb-4" style={{maxWidth: '100%', height: '300px', position: 'relative'}}>
                            <a href="https://goo.gl/maps/XYZ" target="_blank" rel="noreferrer">
                                {/* Use a static map image or iframe here. Using a placeholder for now to match look */}
                                <img 
                                    src="https://static.maps.copilot.microsoft.com/bg/v1/map?w=800&h=400&c=47.026,28.832&z=15" 
                                    alt="Map Location" 
                                    style={{width: '100%', height: '100%', objectFit: 'cover'}}
                                />
                                <div style={{position: 'absolute', bottom: '10px', left: '10px', backgroundColor: 'white', padding: '5px 10px', fontSize: '12px', borderRadius: '2px', boxShadow: '0 2px 4px rgba(0,0,0,0.2)'}}>
                                    <strong>Government House...</strong><br/>
                                    <span className="text-primary">View larger map</span>
                                </div>
                            </a>
                        </div>
                    </div>

                    {/* --- CONTACT FORM --- */}
                  {/* --- CONTACT FORM --- */}
<div className="card shadow-sm border-0 p-4">
    <h5 className="mb-4 fw-bold text-uppercase" style={{ color: mainColor }}>
        Trimite un mesaj
    </h5>

    <form>
        <div className="row">
            <div className="col-md-6 mb-3">
                <label className="form-label fw-semibold text-secondary">
                    Numele dumneavoastră <span className="text-danger">*</span>
                </label>
                <input
                    type="text"
                    className="form-control rounded-0"
                    placeholder="Introduceți numele"
                    required
                />
            </div>

            <div className="col-md-6 mb-3">
                <label className="form-label fw-semibold text-secondary">
                    Adresa de e-mail <span className="text-danger">*</span>
                </label>
                <input
                    type="email"
                    className="form-control rounded-0"
                    placeholder="exemplu@email.com"
                    required
                />
            </div>
        </div>

        <div className="mb-3">
            <label className="form-label fw-semibold text-secondary">
                Subiect <span className="text-danger">*</span>
            </label>
            <input
                type="text"
                className="form-control rounded-0"
                placeholder="Subiectul mesajului"
                required
            />
        </div>

        <div className="mb-4">
            <label className="form-label fw-semibold text-secondary">
                Mesaj <span className="text-danger">*</span>
            </label>
            <textarea
                className="form-control rounded-0"
                rows="5"
                placeholder="Scrieți mesajul dumneavoastră aici..."
                required
            ></textarea>
        </div>

        {/* Fake Captcha */}
        <div className="mb-4 d-flex align-items-center gap-2 p-3 border bg-light">
            <input className="form-check-input" type="checkbox" id="captcha" />
            <label htmlFor="captcha" className="form-check-label small">
                I'm not a robot
            </label>
        </div>

        <button
            type="submit"
            className="btn rounded-0 px-4 py-2 fw-bold"
            style={{
                backgroundColor: mainColor,
                color: '#fff'
            }}
        >
            Trimite mesajul
        </button>
    </form>
</div>

                </div>
            </div>
        </div>
    );
};

export default Messages;